import { useQuery } from '@tanstack/vue-query'
import { getRefundStatusCounts } from '../refundsEndpoints'
import { refundKeys } from '../refundsQueryKeys'

export function useRefundStatusCountsQuery() {
  return useQuery({
    queryKey: refundKeys.statusCounts(),
    queryFn: () => getRefundStatusCounts(),
    staleTime: 1000 * 30,
  })
}
